const initialState = {
  countries: [],
  countries_loading: false,
  parcel_terminals: {
    omniva: {},
    dpd: {},
    lp_express: {},
    venipak: {},
    posti: {},
    matkahuolto: {}
  },
  parcel_terminals_loading: false,
  pickup_addresses: [],
  pickup_addresses_loading: false,
  order_shops: [], 
  order_shops_loading: false 
}

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_OPTIONS":
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}
